import { useState, useEffect,useRef } from "react";
import React from 'react';
import {
  Badge,
  Card,
  CardHeader,
  CardFooter,
  Button,
  Table,
  Container,
  Row,
  Col,
  Form,
  Input,
} from "reactstrap";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-community/dist/styles/ag-theme-alpine-dark.css";
import "../../assets/css/custom.css";
import Header from "components/Headers/Header.js";
import { clientmanageService } from "../../services/clientmanageService.js";
import 'assets/css/themecustom-style.css';
import { ToastContainer, toast } from 'react-toastify';
import '@flowjs/flow.js';
import { useHistory,useParams } from "react-router-dom";
const axios = require("axios");

const ViewClientTransitionForm = (props) => {
  const params  = useParams();
  const [formdetails,setformdetails] = useState({});
  const [state, setState] = useState({});
  const [ctrans, setCurrentTrans] = useState('');
  const [disablestate, setdisablestate] = useState(false);
  const [errors, setErrors] = useState({});


useEffect(() => {
  if(params.client_id!='undefined' && params.client_id!=undefined){
    generateForm(params.client_trans_id,params.client_id,params.trans_id)
  }
}, []);
const [formdetailsLength,setformdetailsLength] = useState({});
const generateForm = (id,client_id,trans_id) => {
  setCurrentTrans(trans_id)
  clientmanageService.generateForm(id,client_id,trans_id).then((response) => {
    setformdetails(response.data);
    setState(response.data);
    

    setformdetailsLength(Object.entries(response.data).length)
  })
}

function inputhandler(e,index,key) {
  let temp_st = {...state};
  let temp_ele = { ...temp_st[key][index] };
  temp_ele.remarks = e.target.value;
  temp_st[key][index] = temp_ele;
  setState(temp_st);

}
function inputhandlernew(e,index) {
  console.log("index",index)
  const { name, value } = e.target;
  let temp_st = {...state};
  if (!temp_st['new_data']) {
    temp_st['new_data'] = [];  
  }

  let temp_ele = { ...temp_st['new_data'][index] };
  temp_ele[e.target.name] = e.target.value;
  temp_ele['trans_id'] = ctrans;
  temp_ele['client_trans_id']=params.client_trans_id;
  temp_ele['client_id']=params.client_id;
  temp_st['new_data'][index] = temp_ele;
  setState(temp_st);
  console.log(state)
        // setState(prevFormData => {
        //     // Create a copy of the previous state
        //     const newData = [...prevFormData];
        //     // Update the specific row with the new value
        //     newData[rowIndex] = {
        //         ...newData[rowIndex],
        //         [name]: value
        //     };
        //     newData[rowIndex]['master_id'] = ctrans;
        //     newData[rowIndex]['phase_id'] = cphase;
        //     newData[rowIndex]['sub_cat'] = csubcat;
        //     return newData;
        // });
      // setState({ ...state, formData });
  }

function validateNewRows() {
  let newErrors = {};
  let isValid = true;
  if (state['new_data']) {
    state['new_data'].forEach((row, index) => {
      if (!row || !row.field_name || row.field_name.trim() === '') {
        newErrors[`field_name_${index}`] = 'Particulars is required';
        isValid = false;
      }
      if (!row || !row.scenerio || row.scenerio.trim() === '') {
        newErrors[`scenerio_${index}`] = 'Scenario is required';
        isValid = false;
      }
      if (ctrans != 1 && (!row || !row.procedures || row.procedures.trim() === '')) {
        newErrors[`procedures_${index}`] = 'Procedures is required';
        isValid = false;
      }
    });
  }
  setErrors(newErrors);
  return isValid;
}

function add_phase_selection(e) {
  setdisablestate(true)
  e.preventDefault();
  if (!validateNewRows()) {
    toast.error('Please fill all required fields.');
    setdisablestate(false);
    return;
  }
  clientmanageService.updateTransitionForm(state).then((response) => {
    console.log(response);

    if (response.status == 200) {
      toast.success(response.data.message);
    }
    setdisablestate(false)
  });
}
function downloadReport(){
  clientmanageService.download_transitionform_report(params.client_id,params.trans_id).then((response) => {
  
  });
}
const [newboxmaster, setNewBoxMaster] = useState(0);
 
const addNewboxMaster = ()=>{
  const setdata = newboxmaster+1;
  setNewBoxMaster(setdata)
  //setformdetailsLength(formdetailsLength + 1)
 
}
const handleclick = (id, rowIndex, isNew = false) => {
  swal({
    title: "Are you sure you want to remove?",
    icon: "warning",
    buttons: true,
    dangerMode: true,
  }).then((isConfirm) => {
    if (isConfirm) {
      if (isNew) {
        // It's a newly added row — remove from state.new_data
        let temp_st = { ...state };
        if (temp_st['new_data']) {
          temp_st['new_data'].splice(rowIndex, 1);
        }
        setState(temp_st);
        setNewBoxMaster(prev => prev - 1);
        toast.success("Row removed.");
      } else {
        // It's an existing row — call API to delete
        clientmanageService.deleteTransitionForm(id).then((response) => {
          if (response.status === 200) {
            toast.success(response.data.message);
            generateForm(params.client_trans_id, params.client_id, ctrans); // ✅ Correct refresh
          } else {
            toast.error('Something went wrong!');
          }
        });
      }
    }
  });
};

  return (
    <>
      <Header />
      <Container className="mt--7"  fluid>
      <CardHeader className="bg-transparent">
                  
                
                  <Row className="align-items-center">
                
                    <div className="col-10">
                      <h4 className="text-uppercase text-muted ls-1 mb-1">
                       Form Data
                      </h4>
                      

                    </div>
                   
                 <Col xl="2">
             <Button
                 className="btn-icon-clipboard"
                 type="button"
                 onClick={downloadReport}
                 style={{textAlign:'center'}}
                 title="Download Report"
               >
               <i className="fas fa-download" style={{fontSize:'14px'}}></i> Export
             </Button>
       </Col>
                  </Row>
                </CardHeader>
     
        <Row className="mt-5" >
        
          <div className="col" style={{padding:'0%'}}>
          <Form
                role="form"
                id="phase-selection-form"
                onSubmit={add_phase_selection}
            
              >
              <Table  className="align-items-center table-flush" responsive>
                <thead>
                  <tr style={{border : "1px solid #000"}}>
                     <th style={{border : "1px solid #000"}}>Sr.No.</th> 
                    <th style={{border : "1px solid #000"}} className="whitespace">Particulars<span style={{color:'red'}}> *</span></th>
                    <th style={{border : "1px solid #000"}} className="whitespace">Scenario<span style={{color:'red'}}> *</span></th>
                    { ctrans != 1 ?
                    <th style={{border : "1px solid #000"}} className="whitespace">Procedures<span style={{color:'red'}}> *</span></th>
                    : null }
                    <th style={{border : "1px solid #000"}} className="whitespace">Client Remarks</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                

      
      {
         Object.entries(formdetails).map(([key, value],index) =>
      
           
           <>
             {value.map((g,i) => (
            <tr className="whitespace" style={{border : "1px solid #000"}}>
              {(i ==0)?
              <><td style={{border : "1px solid #000"}}>{index+1}</td><td style={{border : "1px solid #000"}}>{key}</td></>:<><td style={{border : "1px solid #000"}}></td><td style={{border : "1px solid #000"}}></td></>}
              
             <td className="whitespace" style={{border : "1px solid #000"}}>{g.scenerio}</td>
             { ctrans != 1 ?
             <td className="whitespace" style={{width:"50%",border : "1px solid #000"}}>{g.procedures}</td>
             : null }
             <td className="whitespac
             e" style={{width:"50%",border : "1px solid #000"}}><Input
                         
                         bsSize="sm"
                         name="form-remarks"
                         placeholder="Remarks"
                         id="example-date-input"
                         type="textarea"
                         value={g.remarks ? g.remarks : ""}
                         onChange={(e) => inputhandler(e, i,key)}
                         

                         
                       /></td>
              <td style={{border : "1px solid #000"}}>
                   <Button
                      className="btn btn-danger"
                      onClick={() => handleclick(g.main_id, i, false)}
                    >
                      <i className="fa fa-trash"></i>
                    </Button>
                  
              </td>
             </tr>
           ))}
           </>
        //  </tr>
       )
      }
    


    {(() => {
            const arr1 = [];
            for (let key = 0; key < newboxmaster; key++) {
                arr1.push(
                  <>
                  <tr className="whitespace" style={{border : "1px solid #000"}}>
                  <td className="whitespace" style={{border : "1px solid #000"}}>
                  {formdetailsLength + key + 1}
                  </td>
                  <td className="whitespace" style={{border : "1px solid #000"}}>
                                <input  className={`form-control ${errors[`field_name_${key}`] ? 'is-invalid' : ''}`} type="text" name="field_name" onChange={(e) => inputhandlernew(e,key)}   />
                                {errors[`field_name_${key}`] && <div className="invalid-feedback">{errors[`field_name_${key}`]}</div>}
                                </td>
                  <td  className="whitespace" style={{border : "1px solid #000"}}>
                  <input  className={`form-control ${errors[`scenerio_${key}`] ? 'is-invalid' : ''}`} type="text" name="scenerio" onChange={(e) => inputhandlernew(e,key)}   />
                  {errors[`scenerio_${key}`] && <div className="invalid-feedback">{errors[`scenerio_${key}`]}</div>}
                  </td>
                  { ctrans != 1 ?
                          <td  className="whitespace" style={{border : "1px solid #000"}}>
                          <input  className={`form-control ${errors[`procedures_${key}`] ? 'is-invalid' : ''}`} type="text" name="procedures" onChange={(e) => inputhandlernew(e,key)}   />
                          {errors[`procedures_${key}`] && <div className="invalid-feedback">{errors[`procedures_${key}`]}</div>}
                            </td>
                             : null }
                            <td className="whitespac
             e" style={{width:"50%",border : "1px solid #000"}}><Input
                         
                         bsSize="sm"
                         name="remarks"
                         placeholder="Remarks"
                         id="example-date-input"
                         type="textarea"
                        
                         onChange={(e) => inputhandlernew(e,key)}
                         

                         
                       /></td>
                       <td style={{width:"50%",border : "1px solid #000"}}>
                        <Button
                          className="btn btn-danger"
                          onClick={() => handleclick(null, key, true)}
                        >
                          <i className="fa fa-trash"></i>
                        </Button>
                        </td>
                  </tr>
                  </>
                  );
                }
                return arr1;
                
            })()}      
                </tbody>
              </Table>
             
              <row>
              <Button color="primary"  style={{flex:"0 0 4.66667%"}} type="button" onClick={(e) => addNewboxMaster()} >
              <i class="fa fa-plus"></i>  Add 
              </Button>
              </row>
              <br></br><br></br>
              </Form>
              
              <Button color="primary" className="col-xl-2" type="button" onClick={add_phase_selection} disabled={disablestate}>
            {disablestate ? 'Sending...' : 'Save'} 
              </Button>
          </div>
        </Row>
        
      </Container>
    </>
  );
};


export default ViewClientTransitionForm;
